$shm_hitalama_map_widget_float_table_command $mol_button_minor
